import { create } from 'zustand';

interface TickerState {
  data: Record<string, any>;
  ws: WebSocket | null;
  isConnecting: boolean;
  connect: (symbols: string[]) => Promise<void>;
  closeWS: () => Promise<void>;
}

const buildStreamUrl = (symbols: string[]) =>
  `wss://fstream.binance.com/stream?streams=${symbols.map((s) => `${s}@ticker`).join('/')}`;

export const useTickerStore = create<TickerState>((set, get) => ({
  data: {},
  ws: null,
  isConnecting: false,

  connect: async (symbols) => {
    if (get().isConnecting) {
      return;
    }

    set({ isConnecting: true });
    await get().closeWS();

    const ws = new WebSocket(buildStreamUrl(symbols));


    ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      if (message.stream && message.data) {
        const symbolKey = message.stream.split('@')[0];
        set((prev) => ({
          data: { ...prev.data, [symbolKey]: message.data },
        }));
      }
    };

    ws.onclose = (event) => {
      set({ ws: null });
    };

    ws.onerror = (err) => {
      ws.close();
    };

    set({ ws, isConnecting: false });
  },

  closeWS: () => {
    const { ws } = get();
    if (ws) {
      return new Promise<void>((resolve) => {
        ws.onclose = () => {
          set({ ws: null });
          try {
            ws.onopen = null;
            ws.onmessage = null;
            ws.onerror = null;
            ws.onclose = null;
          } catch (e) {
            console.warn('useTickerStore WebSocket Error:', e);
          }
          resolve();
        };
        ws.onerror = null;
        ws.close();
      });
    } else {
      set({ ws: null });
      return Promise.resolve();
    }
  },

}));
